<template>
  <vx-card id="app_body" class="flex-1 flex-col w-full lg:ml-base relative">
    <global-header :buttonBack="true" :actions="false"></global-header>
    <div class="w-full">
      <div
        v-if="$route.name === 'buat-surat'"
        class="w-full flex flex-col p-5 md:flex-row md:justify-between md:h-full md:items-center"
      >
        <item-select
          v-for="(item, index) in create.typeLists.filter(i => i.isShow)"
          :item="item"
          :key="index"
        ></item-select>
      </div>
      <router-view></router-view>
    </div>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
import CreateInbox from "./CreateInbox.vue";
import CreateOutbox from "./CreateOutbox.vue";
import ItemSelect from "./ItemSelect.vue";

import { mapState } from "vuex";

export default {
  components: {
    "vs-select": vSelect,
    CreateInbox,
    CreateOutbox,
    ItemSelect
  },
  props: {
    selected: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      create: state => state.surat.create
    })
  },
  mounted() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Pilih Tipe Surat");
  }
};
</script>
